// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__V730S","inner":"Footer_inner__vZHM4"};